<template>
    <div>
        <!-- Organization level -->
        <template v-if="$route.params.oid">
            <v-container fluid>
                <v-row>
                    <v-col>
                        <v-card flat color="grey lighten-3">
                            <v-card-title>Space admins</v-card-title>
                            <v-card-text>
                                <dashboard-loader v-if="fetchingOrgLevelData"></dashboard-loader>
                                <template v-else>
                                    <template v-if="spaceAdmins.length > 0 && !$isError(spaceAdmins)">
                                        <div v-for="(admin, i) in spaceAdmins" :key="i" class="py-1">
                                            {{ admin.full_name }}:
                                            <v-chip class="mx-2">
                                                {{ admin.email }}
                                            </v-chip>
                                            <copy-to-clipboard :textToCopy="admin.email" :iconButton="true"></copy-to-clipboard>
                                        </div>
                                    </template>
                                    <dashboard-empty v-if="spaceAdmins.length === 0"></dashboard-empty>
                                    <dashboard-error v-if="$isError(spaceAdmins)"></dashboard-error>
                                </template>
                            </v-card-text>
                        </v-card>
                    </v-col>
                </v-row>
            </v-container>
        </template>
        <!-- RP level -->
        <template v-else>
            <v-container fluid>
                <v-row>
                    <v-col>
                        <v-card flat color="grey lighten-3">
                            <v-card-title>Managers</v-card-title>
                            <v-card-text>
                                <dashboard-loader v-if="fetchingRPLevelData"></dashboard-loader>
                                <template v-else>
                                    <template v-if="orgManagers.length > 0 && !$isError(orgManagers)">
                                        <div v-for="(manager, i) in orgManagers" :key="i" class="py-1">
                                            {{ manager.full_name }}:
                                            <v-chip class="mx-2">
                                                {{ manager.email }}
                                            </v-chip>
                                            <copy-to-clipboard :textToCopy="manager.email" :iconButton="true"></copy-to-clipboard>
                                        </div>
                                    </template>
                                    <dashboard-empty v-if="orgManagers.length === 0"></dashboard-empty>
                                    <dashboard-error v-if="$isError(orgManagers)"></dashboard-error>
                                </template>
                            </v-card-text>
                        </v-card>
                    </v-col>
                </v-row>
            </v-container>
        </template>
    </div>
</template>

<script>
const CopyToClipboard = () => import('@/components/CopyToClipboard.vue')
const DashboardLoader = () => import('@/components/DashboardLoader.vue')
const DashboardEmpty = () => import('@/components/DashboardEmpty.vue')
const DashboardError = () => import('@/components/DashboardError.vue')

export default {
    name: 'ResourcePoolInventory',
    components: { CopyToClipboard, DashboardLoader, DashboardEmpty, DashboardError },
    props: {
        oid: Number,
        sid: Number
    },
    data() {
        return {
            fetchingRPLevelData: false,
            fetchingOrgLevelData: false,
            orgManagers: [],
            spaceAdmins: [],
            error: null
        }
    },
    created() {
        // Org level or space level
        if (this.$route.params.oid) {
            this.fetchOrgLevelData(this.sid)
        } else {
            this.fetchRPLevelData(this.oid)
        }
    },
    computed: {},
    watch: {},
    methods: {
        async fetchRPLevelData(oid) {
            this.fetchingRPLevelData = true
            try {
                const { data } = await this.$axios.get(`/resource/${this.$route.params.rpid}/org/${oid}/contacts`)
                this.orgManagers = data
            } catch (error) {
                this.orgManagers = error
            }
            this.fetchingRPLevelData = false
        },
        async fetchOrgLevelData(sid) {
            this.fetchingOrgLevelData = true
            try {
                const { data } = await this.$axios.get(`/resource/${this.$route.params.rpid}/space/${sid}/contacts`)
                this.spaceAdmins = data
            } catch (error) {
                this.spaceAdmins = error
            }
            this.fetchingOrgLevelData = false
        }
    }
}
</script>
